"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripEndZero = stripEndZero;

var _util = require("@plugnet/util");

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const STRIP_ZERO = /^(.*?)(0*)$/;
/**
 * trim all trailing zeros. return '' if only zero is passed in.
 * @param value
 */

function stripEndZero(value) {
  (0, _util.assert)(!(0, _util.isUndefined)(value), 'must not be undefined');
  return STRIP_ZERO.exec(value)[1];
}